import React, { memo, useState } from 'react';
import { v4 } from 'uuid';
import Modal from 'components/shared/Modal/Modal';
import Accordion from 'components/shared/Accordion/Accordion';
import { IconLoader } from 'common/IconLoader';
import { F_DL_FormulaValues } from 'common/utils/constants';
import LTESignalChart from './LTESignalChart';
import './LTEDetailsModal.css';

const LTEDetailsModal = ({ device, isGa2 = false, onClose }) => {
  const [titleId] = useState(() => v4());
  let lteFrequency = 'N/A';
  let pcid = 'N/A';
  let earfcn = 'N/A';

  // More info section
  let imei = 'N/A';
  let imsi = 'N/A';
  let iccid = 'N/A';
  let lteFwVer = 'N/A';
  let lteHwVer = 'N/A';
  let ip = 'N/A';

  console.log(device, device?.properties?.reported?.lteInfo, 'DEVICESJDSJKSDJSLDJLSDJSLDJ');
  // if isGa2 then pick it from device?.properties?.reported?.DU?.['modem-info']
  if (isGa2) {
    if (device.properties.reported.DU['modem-info']?.cellInfo?.earfcn != null) {
       earfcn = <LTESignalChart deviceId={device.id} preferenceId="ga2_lte-freq" title="LTE frequency" />
      pcid = <LTESignalChart deviceId={device.id} preferenceId="ga2_cell_identifier" title="Cell identifier" />

      for (var i = 0; i < F_DL_FormulaValues.length; i++) {
        if (earfcn >= F_DL_FormulaValues[i][2] && earfcn <= F_DL_FormulaValues[i][3]) {
          lteFrequency = F_DL_FormulaValues[i][0] + (earfcn - F_DL_FormulaValues[i][1]) / 10;
        }
      }
    }

    if (device.properties.reported.DU['modem-info']?.iccid != null) {
      imei = device.properties.reported.DU['modem-info'].imei || 'N/A';
      imsi = device.properties.reported.DU['modem-info'].imsi || 'N/A';
      iccid = device.properties.reported.DU['modem-info'].iccid || 'N/A';
      lteFwVer = device.properties.reported.DU['modem-info'].fwid || 'N/A'; //LTE Firmware Version for GA2 is reported as fwid
      lteHwVer = device.properties.reported.DU['modem-info'].model || 'N/A'; //LTE Hardware Version for GA2 is reported as model
      iccid = device.properties.reported.DU['modem-info'].iccid || 'N/A';
      ip = device.properties.reported.DU['modem-info'].ip || 'N/A';
    }
  } else {
    if (device?.properties?.reported?.lteInfo) {
      if (device.properties.reported.lteInfo?.cellInfo?.earfcn != null) {
        earfcn = device.properties.reported.lteInfo.cellInfo.earfcn;
        pcid = device.properties.reported.lteInfo.cellInfo.pcid;

        for (var i = 0; i < F_DL_FormulaValues.length; i++) {
          if (earfcn >= F_DL_FormulaValues[i][2] && earfcn <= F_DL_FormulaValues[i][3]) {
            lteFrequency = F_DL_FormulaValues[i][0] + (earfcn - F_DL_FormulaValues[i][1]) / 10;
          }
        }
      }

      if (device.properties.reported.lteInfo?.moduleInfo?.imei != null) {
        imei = device.properties.reported.lteInfo.moduleInfo.imei;
        imsi = device.properties.reported.lteInfo.moduleInfo.imsi;
        iccid = device.properties.reported.lteInfo.moduleInfo.iccid;
        lteFwVer = device.properties.reported.lteInfo.moduleInfo.lteFwVer;
        lteHwVer = device.properties.reported.lteInfo.moduleInfo.lteHwVer;
      }
    }
  }

  const resizeModal = (isOpen) => {
    const modalInnerContent = document.querySelector('.Modal_ContentDiv');
    modalInnerContent.style.height = isOpen ? '680px' : '755px';
  };

  return (
    <Modal
      aria-labelledby={titleId}
      width={1380}
      height={680}
      noPadding={true}
      colorize={'#f8f9fa'}
      opaque={true}
      global
      close={onClose}
    >
      <div className="lteDetailsModal_Wrapper">
        <div className="lteDetailsModal_Container">
          <div id={titleId} className="lteDetailsModal_Header">
            LTE Status
          </div>
          <div className="lteDetailsModal_Content">
            <div className="lteDetailsModal_DetailsBox">
              <div className="lteDetailsModal_ContentFrequencyBox">
                <div className="lteDetailsModal_ContentFrequencyBoxHeader">LTE Frequency</div>
                {!isGa2 ? (
                <div className="lteDetailsModal_ContentFrequencyBoxValue">
                  {lteFrequency + ' MHz (EARFCN ' + earfcn + ')'}
                </div>
                ) : (
                  <div className="lteDetailsModal_ContentFrequencyBoxValue">{earfcn}</div>
                )}
              </div>
              <div className="lteDetailsModal_ContentIndentifierBox">
                <div className="lteDetailsModal_ContentIndentifierBoxHeader">Cell Identifier</div>
                <div className="lteDetailsModal_ContentIndentifierBoxValue">{pcid}</div>
              </div>
            </div>
            {!isGa2 ? (
              <div className="lteDetailsModal_ContentChartSection">
                <LTESignalChart deviceId={device.id} preferenceId="local_chart_3" title="LTE Signal Level" />
                <LTESignalChart deviceId={device.id} preferenceId="local_chart_4" title="LTE Signal Quality" />
              </div>
            ) : (
              <div className="lteDetailsModal_ContentChartSection">
                <LTESignalChart deviceId={device.id} preferenceId="local_chart_5" title="LTE Signal Level" />
                <LTESignalChart deviceId={device.id} preferenceId="local_chart_6" title="LTE Signal Quality" />
              </div>
            )}

            <div className="lteDetailsModal_MoreInfoBox">
              <Accordion
                resizeModal={resizeModal}
                iconOpened={IconLoader.icon_moreinfo_exp}
                hoverOpened={IconLoader.icon_moreinfo_exp_hover}
                iconClosed={IconLoader.icon_moreinfo}
                hoverClosed={IconLoader.icon_moreinfo_hover}
              >
                <div label="More Information">
                  <div className="lteDetailsModal_ContentIMEIBox">
                    <div className="lteDetailsModal_ContentIMEIBoxHeader">IMEI</div>
                    <div className="lteDetailsModal_ContentIMEIBoxValue">{imei}</div>
                  </div>
                  <div className="lteDetailsModal_ContentIMSIBox">
                    <div className="lteDetailsModal_ContentIMSIBoxHeader">IMSI</div>
                    <div className="lteDetailsModal_ContentIMSIBoxValue">{imsi}</div>
                  </div>
                  <div className="lteDetailsModal_ContentICCIDBox">
                    <div className="lteDetailsModal_ContentICCIDBoxHeader">ICCID</div>
                    <div className="lteDetailsModal_ContentICCIDBoxValue">{iccid}</div>
                  </div>
                  <div className="lteDetailsModal_ContentFWVerBox">
                    <div className="lteDetailsModal_ContentFWVerBoxHeader">LTE Firmware Version</div>
                    <div className="lteDetailsModal_ContentFWVerBoxValue">{lteFwVer}</div>
                  </div>
                  <div className="lteDetailsModal_ContentHWVerBox">
                    <div className="lteDetailsModal_ContentHWVerBoxHeader">LTE Hardware Version</div>
                    <div className="lteDetailsModal_ContentHWVerBoxValue">{lteHwVer}</div>
                  </div>
                  {isGa2 && (
                    <div className="lteDetailsModal_ContentFWVerBox">
                      <div className="lteDetailsModal_ContentFWVerBoxHeader">IP Address</div>
                      <div className="lteDetailsModal_ContentFWVerBoxValue">{ip}</div>
                    </div>
                  )}
                </div>
              </Accordion>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default memo(LTEDetailsModal);
